import { useEffect, useState } from "react";

const navItems = [
  { label: "Processing Options", href: "#processing-options" },
  { label: "Services", href: "#services" },
  { label: "Local Info", href: "#service-area" },
  { label: "Travel Timing", href: "#travel-timing" },
  { label: "Destinations", href: "#destinations" },
  { label: "Facilities", href: "#acceptance-facilities" },
  { label: "Comparison", href: "#comparison" },
  { label: "FAQ", href: "#faq" },
];

export default function LakeMaryStickyNav() {
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => setSticky(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        sticky
          ? "bg-white shadow-md border-b border-gray-100"
          : "bg-transparent pointer-events-none"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-14 md:h-16">
          <a
            href="https://fastpassportcenter.com"
            className={`font-bold text-sm md:text-base transition-colors ${
              sticky ? "text-[#1A365D]" : "text-white pointer-events-auto"
            }`}
          >
            Fast Passport Center
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3 py-2 rounded-md text-xs font-medium transition-colors whitespace-nowrap ${
                  sticky
                    ? "text-gray-600 hover:text-[#1A365D] hover:bg-gray-50"
                    : "text-white/70 hover:text-white hover:bg-white/10 pointer-events-auto"
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <a
            href="https://fastpassportcenter.com/checkout/"
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-xs font-bold transition-all whitespace-nowrap ${
              sticky
                ? "bg-[#F6C344] text-[#1A365D] hover:bg-[#e5b430]"
                : "bg-[#F6C344] text-[#1A365D] hover:bg-[#e5b430] pointer-events-auto"
            }`}
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </nav>
  );
}